import { useEffect, useState } from "react";
import VirtualTable from "../../../components/custom/VirtualTable";
import { ChoiceEmployee } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";
import styled from "styled-components";
import { Button } from 'reactstrap';
import useModal from "../../../customHooks/useModal";
import ModalConfirm from "./ModalConfirmUnitEnvironment";
import ModalUser from "./ModalUser";
import { notify } from "../../../utils";
import useLoading from "../../../customHooks/useLoading";
import ModalConfirmUnitEnvironment from "./ModalConfirmUnitEnvironment";
import Layout from "../../../components/custom/Layout";

export interface Environment {
    name: string;
    url: string;
    numUsers: number;
}

export type EnvironmentMap = Record<string, Environment>

export type Environments = Array<Environment>;

export default function ManageEnvironment() {

    const { setLoading } = useLoading();
    const { user: { s_unit: s_home_station } } = useUser();
    const [employees, setEmployees] = useState<Array<ChoiceEmployee>>([]);
    const [environments, setEnvironments] = useState<Environments>([]);
    const [selectedEnv, setSelectedEnv] = useState<string>();
    const [updateType, setUpdateType] = useState<'USER' | 'UNIT'>();
    const [employeeId, setEmployeeId] = useState<number>();
    const employee = employees.find(employee => employee.id === employeeId);
    const { modal: modalEnv, setModal: setModalEnv } = useModal();
    const { modal: modalUser, setModal: setModalUser } = useModal();
    const getEnvironmentData = async () => {
        const res = await apiClient.get(`/dev/environment-data/${s_home_station}`);
        const employees: Array<ChoiceEmployee> = res.data.employees;
        const environmentMap: Record<string, string> = res.data.environmentMap;

        setEmployees(employees);

        const envMap: EnvironmentMap = {};
        for (const key in environmentMap) {
            envMap[key] = {
                name: key,
                url: environmentMap[key],
                numUsers: 0
            }
        }

        for (const user of employees) {
            const current = envMap[user.s_environment];
            if (current) {
                current.numUsers++;
            }
        }

        setEnvironments(Object.keys(envMap).map(key => envMap[key]));
    }

    useEffect(() => {
        getEnvironmentData();
    }, [s_home_station]);

    const initUpdateAll = (env: string) => {
        setUpdateType('UNIT');
        setSelectedEnv(env);
        setModalEnv(true);
    };

    const initUpdateUser = (id: number) => {
        setUpdateType('USER');
        setEmployeeId(id);
        setModalUser(true);
    };

    const updateUnitEnvironment = async () => {
        try {
            setLoading(true);
            const res = await apiClient.put(`/dev/unit-environment`, {
                s_home_station,
                s_environment: selectedEnv
            });
            await getEnvironmentData();
            setModalEnv(false);
            notify('Updated');
        } catch (err) {
            notify('Error updating, please try again.', 'error');
        } finally {
            setLoading(false);
        }
    }

    const updateUserEnvironment = async (environment) => {
        try {
            setLoading(true);
            const res = await apiClient.put(`/dev/user-environment`, {
                id: employeeId,
                s_environment: environment
            });
            await getEnvironmentData();
            setModalUser(false);
            notify('Updated');
        } catch (err) {
            notify('Error updating, please try again.', 'error');
        } finally {
            setLoading(false);
        }
    }

    return (
        <Layout>
            <div className={'mb-2'}>
                {
                    environments.map((env, i) => (
                        <FlexContainer>
                            <h6 key={i}>{env.name}: <i>{env.url}</i> = {env.numUsers} users</h6>
                            <Button onClick={() => initUpdateAll(env.name)}>Update all</Button>
                        </FlexContainer>
                    ))
                }
            </div>
            <VirtualTable<ChoiceEmployee>
                data={employees}
                mapping={[{
                    name: 'First name',
                    value: 's_first_name'
                }, {
                    name: 'Last name',
                    value: 's_last_name'
                }, {
                    name: 'Email',
                    value: 's_email'
                }, {
                    name: 'Unit',
                    value: 's_unit'
                }, {
                    name: 'Job',
                    value: 's_job_title'
                }, {
                    name: 'Dept',
                    value: 's_department'
                }, {
                    name: 'EOS Env.',
                    value: 's_environment'
                }]}
                numRows={10}
                handleClick={user => initUpdateUser(user.id)}
            />
            <ModalConfirmUnitEnvironment
                modal={modalEnv}
                setModal={setModalEnv}
                selectedEnv={selectedEnv}
                updateUnitEnvironment={updateUnitEnvironment}
            />
            <ModalUser
                modal={modalUser}
                setModal={setModalUser}
                environments={environments}
                employee={employee}
                updateUserEnvironment={updateUserEnvironment}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
    margin: 10px 0px;
    gap: 10px;
`;